<template>
  <div :class="['current-card']">
    <img class="attachment" v-if="attributes.attachment" :src="getSource(attributes.attachment)"/>
    <div class="content">
      <h3 :class="['date', attributes.noun.replace(' ', '-'), {future: new Date(attributes.start) > new Date()}]" v-markdown="attributes.daystring"></h3>
      <h4 v-markdown="attributes.title"></h4>
      <p class="party" v-markdown="attributes.party"></p>
      <p class="constituency" v-markdown="attributes.constituency"></p>

      <div class="btns">
        <a class="live-link" v-if= "attributes.noun==='happening now' && attributes['link-live']" :href="attributes['link-live']" target="_blank">Go to live coverage</a>
        <a @click="moreDetails">More details</a>
        <a v-if="new Date(attributes.end) > new Date() && attributes.noun !== 'happening now'" target="_blank" :href="`https://www.google.com/calendar/render?action=TEMPLATE&amp;text=${attributes.title}&amp;dates=${googleDateFormat(attributes.start)}/${googleDateFormat(attributes.end)}&amp;details=${attributes['calendar-desc']}&amp;location=Singapore&amp;sprop=&amp;sprop=name:`">Add to Google Calendar +</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'event-card',
  props: ['attributes'],
  data () {
    return {
    }
  },
  methods: {
    getSource (value) {
      if (value && !value.substring(0, 10).includes('://')) {
        return require(`images/${value}`)
      }
      return value
    },
    moreDetails () {
      this.$store.commit('pushResponse', {
        eventpopdata: this.attributes
      })
    },
    googleDateFormat (val) {
      var newVal = val
      if (!newVal) {
        newVal = this.attributes.start
      }
      return this.$googleDateFormat(newVal)
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.current-card {
  display: inline-block;
  background-color: #FFF;
  border-radius: 10px;
  margin-right: 10px;
  width: 280px;
  height: 500px;
  vertical-align: bottom;
  overflow: hidden;

  @include breakpoint($d_normal) {
    width: 350px;
  }

  .content {
    padding: 15px;
  }

  h4 {
    font-size: 16px;
    line-height: 1.3em;
  }

  p {
    font-size: 16px;
    font-family: $font-CuratorRegular;
    line-height: 1.3em;
  }

  img {
    margin: 0 auto;
    display: block;
    /* max-width: 100%;
    max-height: 300px; */
    width: 100%;
    height: 187px;
    object-fit: cover;
    object-position: center center;

    @include breakpoint($d_medium) {
      height: 234px;
    }
  }

  .date {
    padding-bottom: 10px;
    text-transform: uppercase;
    font-family: $font-CuratorRegular;
    font-size: 15px;
    color: rgba(12, 43, 87, 0.2);

    &.future {
      color: rgba(12, 43, 87, 0.5);
    }
    &.happening-now {
      color: #D6445C;
    }
    &.today {
      color: #0C2B57;
    }
  }

  .constituency {
    color: #808080;
  }

  .btns {
    padding-top: 20px;
    a {
      font-family: $font-CuratorRegular;
      color: #333;
      font-size: 14px;
      border: 1px solid #e6eae9;
      padding: 4px 20px;
      border-radius: 25px;
      margin: 0 7px 10px 0;
      display: inline-block;

      &.live-link {
        background-color: #D6445C;
        border: none;
        color: #FFF;
      }

    }
  }
}
</style>
